// removed by extract-text-webpack-plugin
module.exports = {"contactForm":"styles__contactForm__2g7uT","purple":"styles__purple__QI0yj","subHeading":"styles__subHeading__2U9Bg"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/GetStarted/styles.scss
// module id = 424
// module chunks = 0